import { render, staticRenderFns } from "./LiveChat.vue?vue&type=template&id=6cdd8665&"
import script from "./LiveChat.vue?vue&type=script&lang=js&"
export * from "./LiveChat.vue?vue&type=script&lang=js&"
import style0 from "./LiveChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports